// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__l4SQT","modalBody":"StaffClientsModal_modalBody__rivIw","formControl":"StaffClientsModal_formControl__xLnw1"};